import React, { useEffect, useState } from "react";
import EditModal from "../../components/form_elements/edit-modal";
import DependentForm from "./dependent-form";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from 'yup';
import {RequiredDate, RequiredFile, RequiredString,OptionalBoolean,OptionalFile, OptionalCheckbox, OptionalString} from "../../components/form_elements/form-validators";
import useMsalApi from "../../components/use-msal-api";
import { mapProperties } from "../../components/property-mapper";
import { updateDependent, addAttachment, updateSelection } from "../../redux/actions/enrollments-actions";
import { createGuid, getExistingContact } from "../../components/contact-builder";
import { DependentRelationship } from "../../components/enums/dependent-relationship";

const DependentEdit = ({dependent, setDependent, show, setShow}) => {

    const [submitting, setSubmitting] = useState();
    const dispatch = useDispatch();
    const onClose = () => {setDependent({});}
    const [relationships, setRelationships] = useState();
    const enrollments = useSelector(s => s.enrollments);
    const [callApi] = useMsalApi();
    const [attachments, setAttachments] = useState([]);
    const [updated, setUpdated] = useState();
    
    const validationSchema = Yup.object().shape({
        firstName: RequiredString("Required"),
        lastName:  RequiredString("Required"),
        birthdate: RequiredDate("Required").max(new Date(), 'Invalid Date'),
        ssn: OptionalString().when("noSsn", {is: !true, then: RequiredString("Required")}).test("", "SSN must be 9 digits", (item) => item ? item.length === 11 : true)
        .test("", "Not a valid SSN", (item) =>  item ? /^(?!(000|666|9))(\d{3}-?(?!(00))\d{2}-?(?!(0000))\d{4})$/.test(item) : true)
        .test("", "Not a valid SSN", (item) =>  item ? item !== "123-45-6789" : true)
        .test("", "Not a valid SSN", (item) =>  item ? item !== "111-11-1111" : true)
        .test("", "Not a valid SSN", (item) =>  item ? item !== "222-22-2222" : true)
        .test("", "Not a valid SSN", (item) =>  item ? item !== "333-33-3333" : true)
        .test("", "Not a valid SSN", (item) =>  item ? item !== "444-44-4444" : true)
        .test("", "Not a valid SSN", (item) =>  item ? item !== "555-55-5555" : true)
        .test("", "Not a valid SSN", (item) =>  item ? item !== "777-77-7777" : true)
        .test("", "Not a valid SSN", (item) =>  item ? item !== "888-88-8888" : true),
    relationshipId:  RequiredString("Required"),
        genderId:  RequiredString("Required"),
        hasDisability: OptionalBoolean(),
        disabledFile: OptionalFile(),
        noSsn: OptionalCheckbox()
    });

    useEffect(() => {
        const getRelationships = async () => {
            var results = await callApi("lookup/relationships", "GET");
            if(!results.error){
                setRelationships(results);
            }
        }
        getRelationships();
    }, [])

    const onSubmit = async(formData) => {
        console.log('form',formData);
        const frm = validationSchema.cast(formData);
        if(submitting)return;
        setSubmitting(true);
        let contact = {...dependent};
        if(!contact.id){
            const existing = getExistingContact(enrollments.contacts, frm.lastName, frm.firstName, frm.birthdate);
            if(existing){
                contact.id = existing.id;
            }else{
                contact.id = createGuid();
            }
        }
        contact.firstName = frm.firstName;
        contact.lastName = frm.lastName;
        contact.relationship = { id: frm.relationshipId, name: relationships.find(s => s.id === frm.relationshipId).name};
        contact.gender =  {id :frm.genderId, name:enrollments.genders.find(s => s.id === frm.genderId).name};
        contact.ssn = frm.ssn;
        contact.birthdate = frm.birthdate;
        contact.hasDisability = frm.hasDisability;
        const results = await callApi(`Enrollments/${enrollments.id}/dependent`, "PATCH", contact);
        if(!results.error){
            let updatedDependent = dependent.id ? mapProperties(results, {...dependent}) : results;
            dispatch(updateDependent(updatedDependent));
            setUpdated(true);
            console.log("Attachments", attachments);
            await attachments.forEach(async a =>  {
                const frmData = new FormData();
                frmData.append("file", a.file);

                const uploadResult = await callApi(`Attachment/${enrollments.id}/${a.type}`, "POST", frmData, "multipart/form-data");
                if(!uploadResult.error){
                    dispatch(addAttachment(uploadResult));
                }
            });
            
            setAttachments([]);
            setSubmitting(false);
            setShow(false);
        }
    }

    const onError = (errors, e) => {
        console.log(errors, e);
    }

    return(
        <EditModal 
            title="Dependent" 
            schema={validationSchema}  
            onError={onError} 
            onSubmit={onSubmit} 
            show={show} 
            setShow={setShow} 
            initialValues={dependent} 
            submitting 
            onClose={onClose}
            focusElement="input"
        >
            <DependentForm dependent={dependent} setDependent={setDependent} relationships={relationships} show={show} attachments={attachments} setAttachments={setAttachments} />
        </EditModal>
    );
}

export default DependentEdit;